<template>
  <div class="container-xxl"   >
      <ul>
        <li>
          <div class="mt-3" style="margin-left: -0.5rem;" >            
            <a-alert :message="'目前可用學分:'+myTotalScore" type="success" />
            <div class="year-picker-bar">
              <label for="year-picker" style="font-weight:bold; font-size:1rem;">
                選擇年度 : 
              </label>
              <vuejs-datepicker 
                id="year-picker"
                :value="this.defaultDate"
                :format="DatePickerFormat"
                :language="language"
                :bootstrap-styling="true"
                v-model="yDate"
                @selected="doYDate"
                minimum-view="year"            
              ></vuejs-datepicker>            
            </div>
            <a-tabs v-model="activeTab">
              <a-tab-pane key="score" tab="活動成績查詢" >
                <!-- 原本的查詢內容 -->
                <div>
                  <Actscore :useid="useid" :yDate="setDates(yDate)" ref="con2"/>
                </div>
              </a-tab-pane>
              <a-tab-pane key="other" tab="其它查詢">
                <!-- 新增的查詢頁面內容 -->
                <div>
                <a-table v-if="Array.isArray(myData) && myData.length > 0"
                    :columns="columns"
                    :row-key="record => record.id"
                    :data-source="myData"
                    :pagination="pagination"
                    :loading="loading"
                    @change="handleTableChange"
                    bordered
                >    
                <template slot="card" slot-scope="record">
                  <a-card style="margin-bottom: 16px;">
                    <div class="score-card-row">
                      <div class="score-card-col no-wrap">
                        <b>執行人：</b>{{ record.tdisplayname }}
                      </div>
                      <div class="score-card-col no-wrap">
                        <b>接收人：</b>{{ record.udisplayname }}
                      </div>
                      <div class="score-card-col">
                        <b>學分：</b>
                        <span :style="{color: record.amount > 0 ? 'green' : (record.amount < 0 ? 'red' : 'black'), fontWeight: 'bold'}">
                          {{ record.amount }}
                        </span>
                      </div>
                      <div class="score-card-col">
                        <b>交易類型：</b>{{ coverNameType(record.type) }}
                      </div>
                      <div class="score-card-col">
                        <b>交易動作：</b>{{ coverNameAction(record.action) }}
                      </div>
                      <div class="score-card-col score-card-col-detail">
                        <b>交易說明：</b>{{ record.detail }}
                      </div>
                      <div class="score-card-col">
                        <b>建置時間：</b>{{ fdateformat(record.created_at) }}
                      </div>
                    </div>
                  </a-card>
                </template>                   
                </a-table>
                </div>
              </a-tab-pane>
            </a-tabs>

          </div>
        </li>
      </ul> 
  </div>
</template>
<script>
import {mapState} from 'vuex';
import * as moment from "moment/moment";
import Actscore from './panel/Actscore.vue'
import vuejsDatepicker from 'vuejs-datepicker';
import { joinService } from '../_services'
import 'moment/locale/zh-tw';


const queryData = params => {
  return joinService.findMyPersonalScore(params) 
}; 

const queryTotalScore = params => {
  return joinService.findMyPersonalTotalScore(params) 
};

const columns = [
  {
    title: '', // 或直接不寫 title
    dataIndex: '',
    scopedSlots: { customRender: 'card' }
  }
];

export default {
  name: 'Mymailscore',
  components: {
    Actscore,
    vuejsDatepicker,
  }, 
  props: {
    msg: String
  },
  data() {
    const now = new Date()
    const today = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate())).format("YYYY-MM-DD") 
    return {  
      useid:0,
      defaultDate: today ,
      DatePickerFormat: 'yyyy',
      yDate: moment(today).format("YYYY"),
      activeTab: "score", // 預設顯示成績查詢
      pagination: {defaultPageSize:4}, 
      myTotalScore:0,
      myData:[],
      loading: false,
      columns,       
      language:{
        language: 'Chinese', 
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'], 
        monthsAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'], 
        days: ['日', '月', '火', '水', '木', '金', '土'], 
        rtl: false, 
        ymd: false, 
        yearSuffix: '年'
      }        
    };
  }, 
  computed: {
    ...mapState("account", ["status", "user","linecheck"]),
  },   
  mounted(){
        if(this.user!==null){  
          this.useid = this.user.data.user.id 
          const now = new Date()
          const today = moment(new Date(now.getFullYear(), now.getMonth(), now.getDate())).format("YYYY-MM-DD") 
          this.yDate = moment(today).format("YYYY") 
          this.showDATA();
          this.reload();
          this.getScore();
        }
  },
  methods: {
    doYDate(date) {
       this.yDate=moment(date).format("YYYY");
       this.showDATA();
       this.reload();
       this.getScore();
    },    
    changedYear(e){
        console.log(e)
    },            

    fdateformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },
    showDATA(){
      setTimeout(() => {
        this.$refs["con2"].fetch(); 
      }, 500);                 

    },
    setDates(val){
        return moment(val).format("YYYY");
    },

    reload(){
      this.fetch({results:4,page:1,pageSize: 4,uid:parseInt(this.user.data.user.id),
        yDate: this.yDate
      });
    },    
    
    handleTableChange(pagination, filters, sorter) {
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetch({
            results: pagination.pageSize,
            page: pagination.current,
            sortField: sorter.field,
            sortOrder: sorter.order,
            uid: parseInt(this.user.data.user.id),
            yDate: this.yDate,
            ...filters,
        });
    }, 
    fetch(params = {}) {
      this.loading = true;
      queryData({
          ...params,
      }).then(({ data }) => {
          const pagination = { ...this.pagination };
          pagination.total = data.info.totail;
          this.loading = false;
          this.myData = data.results;
          this.pagination = pagination; 
      });
    },

     getScore() {
      var params = {uid:parseInt(this.user.data.user.id)}
      queryTotalScore({
          ...params,
      }).then(({ data }) => {
          console.log(data)
          this.myTotalScore = data;
      });
    },

    
    coverNameType(type) {
      if (type === 'earning') return '增加';
      if (type === 'spending') return '扣除';
      return '';
    },

    coverNameAction(action) {
      if (action === 1 || action === '1') return '購物紅利';
      if (action === 2 || action === '2') return '表現優異';
      if (action === 3 || action === '3') return '其它';
      if (action === 4 || action === '4') return '移轉點數';
      if (action === 5 || action === '5') return '未綁定LINE帳號交易';
      return '';
    },    
  },      
}
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.sidenav a:hover {
  color: #064579;
}
.applyfooter {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   height: 0px;
   background-color: #f0f8f8;
   color: #f0f8f8;
   text-align: center;
   
}
.contantdiv{
  margin: 5px;
  overflow-x: hidden;
}

::v-deep .tab-pane-left {
  text-align: left;
}

.container-xxl {
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  max-width: 900px; /* 或你想要的寬度 */
  text-align: left !important;
  display: block;
}

.score-card-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  align-items: flex-start;
}

.score-card-col {
  min-width: 140px;
  max-width: 220px;
  flex: 1 1 130px;
  margin-bottom: -3px;
  word-break: break-all;
  white-space: nowrap;           /* 不換行 */
  overflow: hidden;              /* 超出隱藏 */
  text-overflow: ellipsis;       /* 超出顯示... */
}

.no-wrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.score-card-col-detail {
  flex-basis: 100%;
  max-width: 100%;
}

@media (max-width: 768px) {
  .score-card-row {
    flex-direction: column;
    gap: 6px 0;
  }
  .score-card-col,
  .score-card-col-detail {
    max-width: 100%;
    flex-basis: 100%;
  }
}
::v-deep .ant-table-thead {
  display: none !important;
}

.year-picker-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 2px;
  margin-bottom: 12px;
  padding: 12px 18px;
  border: 1.5px solid #b3d8fd;
  background: #f8fafc;
  border-radius: 10px;
  box-shadow: 0 2px 8px #b3d8fd22;
}
.score-card-col-detail {
  flex-basis: 100%;
  max-width: 100%;
  white-space: normal;   /* 讓內容自動換行 */
  word-break: break-all; /* 長字也能斷行 */
}


</style>

